import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { Commission } from './commission.model';

@Component({
  selector: 'cs-commission-approval',
  standalone: false,
  templateUrl: './commission-approval.component.html',
  styleUrls: ['./commission-approval.component.scss']
})
export class CommissionApprovalComponent implements OnInit, OnDestroy {
  public commissions: Array<Commission>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;
  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getCommissions()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.commissions = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: Commission): void {
    this.router.navigate(['/crm/customers/commission-approval/approval'], {
      queryParams: { commissionId: request.commissionId }
    });
    this.closeTodo.emit();
  }
}
